import React from 'react';
import classNames from 'classnames';
import { formatTimestampAsDateWithTime } from '../../../utils/dates-utils';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const UserIcon = ({ classes }) => {
  return <span className={classNames(classes.customIcon, classes.replyIcon)}>
    <FormattedMessage id="freshdesk.ticket.me" defaultMessage="ME" />
  </span>;
};

export const SupportIcon = ({ classes }) => {
  return <span className={classNames(classes.customIcon, classes.supportIcon)}>
     <FormattedMessage id="freshdesk.ticket.support" defaultMessage="ES" />
  </span>;
};

export const TicketDetails = ({ name, timestamp, isUser, classes }) => {
  return <div className={isUser ? classes.ticketDetails : classes.commentDetails}>
    {isUser ? <UserIcon classes={classes} /> : <SupportIcon classes={classes} />}
    {name && <p className={classes.ticketName}>{name}</p>}
    {timestamp && <p className={classes.ticketTimestamp}>{formatTimestampAsDateWithTime(timestamp)}</p>}
  </div>;
};

TicketDetails.propTypes = {
  name: PropTypes.string,
  timestamp: PropTypes.string,
  isUser: PropTypes.bool,
};